// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  routeMapParts: new Map([
    ['default', 'https://remito-parts-dev.musea2.azure.ext.gm.com'],
  ]),
  routeMapVehicle: new Map([
    ['default', 'https://remito-vehicle-dev.musea2.azure.ext.gm.com'],
  ]),
  production: false,
  environmentName: 'dev',
  homeUrl:'/api/home',
  userUrl:'/api/users',
  currentUserUrl:'/api/current/user',
  remitoUrl:'/api/remitos',
  remMotivoUrl: '/api/remMotivos',
  docksUrl: '/api/remDocks',
  transporteApiEndpoint: '/api/transporte',
  destApiEndpoint: "/api/destinatario",
  solicitantesUrl:'/api/solicitantes',
  almacenesUrl:'/api/almacenes',
  ptoEmisionUrl: '/api/ptoEmision',
  caiUrl: '/api/cai',
  destinoTransportistasUrl: '/api/destinoTransportistas',
  vehOrigenUrl: '/api/vehOrigen',
  CommonDataUrl: '/api/common',
  mgoErrorUrl: '/api/mgoerror',
  reportUrl:'/api/reports',
  openItemsUrl:'/api/reports',
  vehicleRemitosUrl:'/api/vehicle_remitos',
  vehicleOnHoldUrl:'/api/vehicle_onHold',
  vinVehicleUrl: '/api/vehiculos',
  impresorasUrl: '/api/impresoras',
  tpreApiEndpoint: "/api/tpre",
  otdsUrl: "/api/otdsfilereprocess",
  excelUrl: "/api/excel/download",
  uploadUrl: "/api/file/upload",
  scheduledTaskStatusUrl: "/api/scheduledTasks",
  auth: {
    "issuer": "https://login.microsoftonline.com/6baa4eb1-106a-440b-b4f6-50134497d36d/v2.0",
    "clientId": "bb9ead43-3b62-499c-81ce-6ae4c7a7e542",//"18072e32-809c-4ff0-a13f-4b0d4874b077",
    "redirectUri": window.location.origin,
    "timeoutFactor":.33,
    "silentRefreshTimeout":420,
    "silentRefreshShowIFrame":true,
    "sessionChecksEnabled":true,
    "sessionCheckIntervall":200,
    "skipSubjectCheck":true,
    "useIdTokenHintForSilentRefresh":true,
    "responseType": "code",
    "scope": "openid profile email api://remitos-dev.cp-epg3i.gm.com/.default",
    "showDebugInformation": true,
    "strictDiscoveryDocumentValidation": false,
    "preserveRequestedRoute": true
  },


};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
